import { useAppDispatch, useAppSelector } from "@/Hook/hooks";
import { getDataAnalyticsConfig } from "@/Redux/Ducks/dataAnalyticsSlice";
import { getScreenConfig } from "@/Redux/Ducks/entryFormSlice";
import { getReportConfig } from "@/Redux/Ducks/reportExplorerSlice";
import { ControlTranslation } from "AlignComponents";
import { Card } from "react-bootstrap";
import { HiStar } from "react-icons/hi";
import { IoLinkSharp } from "react-icons/io5";

const Favorites = () => {
  const dispatch = useAppDispatch();
  const userFavorites = useAppSelector(x => x.User.userFavorites);

  const routeToObject = (objectcontrollerno: string, objecttype: string) => {
    switch (objecttype) {
      case "ENTRY FORM":
        dispatch(getScreenConfig({ processCode: objectcontrollerno }))
        break;
      case "DATA ANALYTICS":
        dispatch(getDataAnalyticsConfig({ dataAnalyticsno: objectcontrollerno }))
        break;
      case "REPORTS":
        dispatch(getReportConfig({ reportObjectno: objectcontrollerno }))
        break;
    }
  }

  return (
    <div className="widget user-favorites">
      <Card>
        <Card.Header>
          <Card.Title>
            <HiStar size={18} className="icon" />
            <ControlTranslation system={true} controlId="lblfavorites" />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="tiles">
            {
              userFavorites.map(x => (
                <div className="tile" onClick={() => routeToObject(x.objectcontrollerno, x.applicationobjecttype)}>
                  <IoLinkSharp size={28} />
                  {x.objectcontrollerstxt}
                </div>
              ))
            }
          </div>
        </Card.Body>
      </Card>
    </div >
  )
};

export default Favorites;